/* Built In Imports */
/* External Imports */
import { Box } from '@chakra-ui/react';
import { nanoid } from 'nanoid';

/* Internal Imports */
/* Components */
import SectionTitle from '@components/Headings/SectionTitle';
import FaqSection from '@landing_pages/eoe/components/faqs/FaqSection';

/* Services */
/* Styles */
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';

/* Services */

/**
 * Renders the FaqSection component.
 * @param {Object} FaqSection component.
 * @param {string} region - Region of page
 * @param {string} lang - Language of page
 * @returns {ReactElement} FaqSection component.
 */
const FaqSectionSIA = ({ sectionContent }) => {
  // console.log(sectionContent, 'faqsectionSia');

  return (
    <Box py="70px" px={{ base: '15px', lg: '0' }} bgColor="#F1EBDF">
      <SectionTitle
        titleObj={{
          title: sectionContent[0]?.titleText,
          titleDecoration: 'flowers',
          titleSubtext: sectionContent[0]?.titleSubtext,
        }}
        w={{ base: '100%', sm: '365px' }}
        lineHeight="35px"
        color="#02026C"
      />
      <Box maxW={930} mx="auto" w="100%">
        {sectionContent.map(faqSection => {
          if (faqSection._modelApiKey === 'faq_section_v2') {
            return (
              <FaqSection key={nanoid()} faqSection={faqSection}></FaqSection>
            );
          }
        })}
      </Box>
    </Box>
  );
};

export default FaqSectionSIA;
